import api from './Api'

export const createFeedWeb = (request: { content: string, imageUrlList: string[] }) => {
    return api.post<number>(`/feed/web`, request);
}

export const updateFeedWeb = (updateFeedWebRequest: IUpdateFeedWebRequest) => {
    return api.patch<boolean>(`/feed/web`, updateFeedWebRequest);
}

export const getFeedListWeb = () => {
    return api.get<Array<IGetFeedListWebResponse>>(`/feed/list/web`);
}

export const getAllGetFeedListWebResponseByMemberId = () => {
    return api.get<IGetMyFeedWebResponse[]>(`/feed/list/my/web`);
}

export const createFeedLikeWeb = (feedId: number) => {
    return api.post<boolean>(`/feed/like/web/${feedId}`);
}

export const deleteFeedLikeWeb = (feedId: number) => {
    return api.delete<boolean>(`/feed/like/web/${feedId}`);
}

export const createFeedClaimWeb = (createFeedClaimWebRequest: ICreateFeedClaimWebRequest) => {
    return api.post<boolean>(`/feed/claim/web`, createFeedClaimWebRequest);
}

export const getFeedWebByFeedId = (feedId: number, responseQuery?: string) => {
    const query = `query getFeedWebByFeedId($feedId:ID!) { getFeedWebByFeedId(feedId: $feedId) { ${responseQuery} } }`
    return api.post<IGraphqlResponse<{ getFeedWebByFeedId: IGetFeedListWebResponseGraphQl }>>('/graphql', { query, variables: { feedId: feedId } })
}

export const getProgramBookingWebByProgramBookingId = (id: number, responseQuery?: string) => {
    const query = `query getProgramBookingWebByProgramBookingId($programBookingId:ID!) { getProgramBookingWebByProgramBookingId(programBookingId: $programBookingId) { ${responseQuery} } }`
    return api.post<IGraphqlResponse<{ getProgramBookingWebByProgramBookingId: IProgramBookingWebResponse }>>('/graphql', { query, variables: { programBookingId: id } })
}

export const createFeedCommentWeb = (createFeedCommentWebRequest: ICreateFeedCommentWebRequest) => {
    return api.post<number>(`/feed/comment/web`, createFeedCommentWebRequest);
}
export const updateFeedCommentWeb = (updateFeedCommentWebRequest: IUpdateFeedCommentWebRequest) => {
    return api.put<boolean>(`/feed/comment/web`, updateFeedCommentWebRequest);
}

export const createFeedCommentClaimWeb = (createFeedCommentClaimWebRequest: ICreateFeedCommentClaimWebRequest) => {
    return api.post<boolean>(`/feed/comment/claim/web`, createFeedCommentClaimWebRequest);
}

export const createFeedCommentLikeWeb = (feedCommentId: number) => {
    return api.post<boolean>(`/feed-comment/like/web/${feedCommentId}`);
}

export const deleteFeedCommentLikeWeb = (feedCommentId: number) => {
    return api.delete<boolean>(`/feed-comment/like/web/${feedCommentId}`);
}

export const deleteFeedCommentWeb = (feedCommentId: number) => {
    return api.delete<boolean>(`/feed/comment/web/${feedCommentId}`);

}